import React from "react";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import CommentIcon from "@mui/icons-material/Comment";
import SettingsIcon from "@mui/icons-material/Settings";

export const ModalComentariosTimelineJDF = ({
    tiempoestimado,
    tiempotranscurrido,
    comentarios,
}) => {
    const capitalizeWords = (str) => {
        return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
    };
    return (
        <div className="analisis-credito-comentarios">
            <div className="analisis-credito-comentarios-header">
                <div className="analisis-credito-comentarios-header-comentarios">
                    <CommentIcon />
                    COMENTARIOS
                </div>
                <div className="analisis-sc-procesos-timeline-footer">
                    <div className="analisis-sc-procesos-timeline-footer-group">
                        <div className="analisis-sc-procesos-timeline-footer-group-cel1">
                            <HourglassTopIcon />
                        </div>
                        <div className="analisis-sc-procesos-timeline-footer-group-cel2">
                            Tiempo Estimado
                        </div>
                        <div className="analisis-sc-procesos-timeline-footer-group-cel3">
                            {tiempoestimado}
                        </div>
                    </div>
                    <div className="analisis-sc-procesos-timeline-footer-group">
                        <div className="analisis-sc-procesos-timeline-footer-group-cel1">
                            <HourglassTopIcon />
                        </div>
                        <div className="analisis-sc-procesos-timeline-footer-group-cel2">
                            Transcurrido
                        </div>
                        <div className="analisis-sc-procesos-timeline-footer-group-cel3">
                            {tiempotranscurrido}
                        </div>
                    </div>
                </div>
            </div>
            <div className="analisis-credito-modal-comentarios-container scroll-4">
                <table cellPadding={0} cellSpacing={0}>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Usuario</th>
                            <th><div>Proceso</div></th>
                            <th><div>Comentario</div></th>
                            <th><div>Fecha</div></th>
                        </tr>
                    </thead>
                    <tbody>
                        {comentarios === undefined ||
                            comentarios === null ||
                            comentarios.length === 0 ? (
                            <></>
                        ) : (
                            comentarios.map((item) => (
                                <tr>
                                    <td className="accc-icon">
                                        <SettingsIcon />
                                    </td>
                                    <td className="accc-usuario">{capitalizeWords(item.usuario)}</td>
                                    <td className="accc-proceso">{item.proceso}</td>
                                    <td>{(item.comentarios)}</td>
                                    <td className="accc-fecha">{item.fecha}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
